import { getFirestore, doc, onSnapshot } from 'firebase/firestore'

class VersionService {
  constructor() {
    this.currentVersion = null
    this.versionListener = null
    this.store = null
  }

  init(store) {
    this.store = store
    this.currentVersion = this.getCurrentVersion()
    this.startVersionMonitoring()
  }

  getCurrentVersion() {
    // Get version from localStorage or set initial version
    const stored = localStorage.getItem('app_version')
    if (stored) {
      return stored
    }
    
    // Set initial version from build time or default
    const initialVersion = process.env.VUE_APP_VERSION || '1.0.0'
    localStorage.setItem('app_version', initialVersion)
    return initialVersion
  }

  startVersionMonitoring() {
    if (this.versionListener) {
      this.versionListener() // Unsubscribe existing listener
    }

    // Listen to version changes in Firestore
    const ref = doc(getFirestore(), 'config', 'app_version')
    this.versionListener = onSnapshot(ref, (d) => {
        if (d.exists()) {
          const remoteVersion = d.data().version
          this.checkForUpdate(remoteVersion)
        }
      }, (error) => {
        console.warn('Version monitoring error:', error)
      })
  }

  checkForUpdate(remoteVersion) {
    if (!remoteVersion || !this.currentVersion) return

    // Simple version comparison - you can make this more sophisticated
    if (remoteVersion !== this.currentVersion) {
      console.log(`New version available: ${remoteVersion} (current: ${this.currentVersion})`)
      
      // Show update banner
      if (this.store) {
        this.store.commit('app/SET_UPDATE_BANNER', true)
      }
    } else {
      // Versions match, hide banner and update stored version
      console.log(`Version up to date: ${remoteVersion}`)
      this.updateCurrentVersion(remoteVersion)
      
      if (this.store) {
        this.store.commit('app/SET_UPDATE_BANNER', false)
      }
    }
  }

  updateCurrentVersion(version) {
    this.currentVersion = version
    localStorage.setItem('app_version', version)
    
    // Hide update banner
    if (this.store) {
      this.store.commit('app/SET_UPDATE_BANNER', false)
    }
  }

  destroy() {
    if (this.versionListener) {
      this.versionListener()
      this.versionListener = null
    }
  }
}

export default new VersionService()
